import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import Input from 'components/molecules/input';
import { IMonitoringAssetForm } from 'types/vehicles-monitoring';

interface IRippleIdFieldProps {
  isLoading: boolean;
}

export const RemarksField: FC<IRippleIdFieldProps> = ({ isLoading }) => {
  const { control } = useFormContext<IMonitoringAssetForm>();

  return (
    <Controller
      control={control}
      name="remarks"
      render={({ value, onChange }) => (
        <Input label={fc('remarks')} readOnly={isLoading} value={value} onChange={onChange} />
      )}
    />
  );
};
